import { type ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { LeadMagnet } from "./LeadMagnet";
import { ChatWidget } from "./ChatWidget";

export function PageLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-col min-h-screen bg-background">
      <Header />
      <main id="main" className="flex-1">
        {children}
      </main>
      <Footer />
      <LeadMagnet />
      <ChatWidget />
    </div>
  );
}
